import { useMemo } from 'react';
import { PropertyUnitType } from 'models/Properties';
import { PropertiesBodyListStyled } from 'pages/agencyProperties/body/PropertiesBody.styles';
import usePropertySettingsInitData from 'pages/property/usePropertySettingsInitData';
import PropertyListItem from 'pages/agencyProperties/item/PropertyListItem';
import usePropertySettingsQuery from 'pages/property/usePropertySettingsQuery';
import { useWatch } from 'react-hook-form';
import { isUidString } from 'utils/stringUtils';

const UnitTypeList = ({
  unitTypes = [],
}: {
  unitTypes: PropertyUnitType[];
}) => {
  const {
    property: { uid: propertyUid },
  } = usePropertySettingsInitData();
  const { setQueryPropertyData } = usePropertySettingsQuery();
  const searchQuery = useWatch({
    name: 'unitTypeSearch',
    defaultValue: '',
  });

  const filteredUnitTypes = useMemo(() => {
    const query = searchQuery?.toLowerCase() || '';
    const isUid = isUidString(query);

    return unitTypes.filter((unitType) => {
      if (isUid) {
        return unitType.uid === query;
      }
      return unitType.name.toLowerCase().includes(query);
    });
  }, [unitTypes, searchQuery]);

  const updateTagsCallback = (updatedTags: string[], unitTypeUid: string) => {
    setQueryPropertyData((oldData) => {
      return oldData.map((p) =>
        p.uid === propertyUid
          ? {
              ...p,
              unitTypes: p.unitTypes?.map((unitType) =>
                unitType.uid === unitTypeUid
                  ? { ...unitType, tags: updatedTags }
                  : unitType,
              ),
            }
          : p,
      );
    });
  };

  return (
    <PropertiesBodyListStyled id="unit-types-list">
      {filteredUnitTypes.map((unitType) => (
        <PropertyListItem
          key={unitType.uid}
          property={unitType}
          updateTagsCallback={(updatedTags) =>
            updateTagsCallback(updatedTags, unitType.uid)
          }
        />
      ))}
    </PropertiesBodyListStyled>
  );
};

export default UnitTypeList;
